import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

import { ApiService } from "../../service/ApiService";

export const getBlogContent = createAsyncThunk(
  "blog/getBlogContent",
  async (params, { rejectWithValue }) => {
    try {
      if (!params) return;

      const { data } = await ApiService.getBlogContent(params);

      return data;
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const getBlogFacts = createAsyncThunk(
  "blog/getBlogFacts",
  async (languageCode, { rejectWithValue }) => {
    try {
      if (!languageCode) return;

      const { data } = await ApiService.getBlogFacts(languageCode);

      return { data, languageCode };
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const saveServerBlogContent = createAction("blog/saveServerBlogContent");
export const saveServerBlogFacts = createAction("blog/saveServerBlogFacts");
